const MENTIONS_REGEX = /\B@[a-z0-9_.-]+/gi;

const getMentions = (html: string) => html.match(MENTIONS_REGEX);

export default (html: string) => {
    const mentions = new Set(getMentions(html));
    if (!mentions.size) {
        return html;
    }

    let output = html;
    mentions.forEach(mention => {
        const username = mention.replace('@', '');

        let href = `/blog/${username}`;

        if (username === 'technikheluz') {
            href = `/catalog/vendor/${username}`;
        }

        output = output.replace(
            new RegExp(mention, 'g'),
            `<a href="${href}" target="_blank" rel="nofollow noopener">${mention} </a>`
        );
    });

    return output;
};
